import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import BizCard from '../../components/UI/BizCard';

const OpenLeads = (props) => (
  <BizCard title="Open Leads">
    <table className="biz-form-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Created On</th>
          <th>Lead Owner</th>
          <th>Project Owner</th>
        </tr>
      </thead>
      <tbody>
        {
          props.leads.map((lead) => {
            const createdStatus = lead.statusLogs.find((entry) => (entry.status === 'lead-created'));
            return (
              <tr key={lead.id}>
                <td><Link to={`/app/lead/${lead.id}`}>{lead.name}</Link></td>
                <td>{new Date(createdStatus.completedAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'long', year: 'numeric' })}</td>
                <td>{lead.leadCreatedBy.name}</td>
                <td>{lead.projectOwner.name}</td>
              </tr>
            );
          })
        }
      </tbody>
    </table>
  </BizCard>
);

OpenLeads.propTypes = {
  leads: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
  })).isRequired,
};

export default OpenLeads;



// WEBPACK FOOTER //
// ./src/pages/leads/OpenLeads.jsx